import { useSectorMark } from '@hooks/useSectorMarkHook';

export const use_NOTICE_FORM_LIST = () => {
  const sectorMark = useSectorMark();
  return [
    {
      label: '公告类型',
      required: true,
      type: 'select',
      name: 'noticeType',
      optionsListKey: 'noticeType'
    },
    {
      label: sectorMark,
      required: true,
      type: 'select',
      name: 'sectorType',
      optionsListKey: 'sector'
    },
    {
      label: '客户单位类型',
      required: false,
      type: 'cascader',
      name: 'customerCompanyType'
    },
    {
      label: '行业',
      required: false,
      type: 'select',
      name: 'industryKey'
    },
    {
      label: '应用方向',
      required: false,
      type: 'cascader',
      name: 'applicationDirectionKey'
    },
    {
      label: '省市',
      required: true,
      type: 'cascader',
      name: 'provinceAndCity',
      placeholder: '请选择省市'
    }
  ];
};
